import React from 'react';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { useBookmarks } from '../contexts/BookmarkContext';

interface BookmarkButtonProps {
  path: string;
  title: string;
}

const BookmarkButton: React.FC<BookmarkButtonProps> = ({ path, title }) => {
  const { isBookmarked, addBookmark, removeBookmark } = useBookmarks();
  const bookmarked = isBookmarked(path);

  const toggleBookmark = () => {
    if (bookmarked) {
      removeBookmark(path);
    } else {
      addBookmark(path);
    }
  };

  return (
    <button
      onClick={toggleBookmark}
      className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors"
      title={bookmarked ? "Remove from bookmarks" : "Add to bookmarks"}
    >
      {bookmarked ? (
        <BookmarkCheck className="h-5 w-5" />
      ) : (
        <Bookmark className="h-5 w-5" />
      )}
    </button>
  );
};

export default BookmarkButton;